export const DEFAULT_COLLECTION_ROWS_PER_PAGE = 50;
